<!--
 * @Author: Gaho
 * @Date: 2024-04-11 09:42:05
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-24 17:06:21
 * @Description: 这是游戏历史窗口上方的游戏信息区
-->
<template>
    <div class="bg-background-80 rounded-xl text-sm p-4 gap-3 flex flex-col font-bold">
        <div class="text-grey-40 inline-flex justify-between items-center w-full">
            <span>{{ t.gameName }}:</span>
            <span :data-game-name="gameName">
                {{ t[gameName] }} 
            </span>
        </div>
        <div class="text-grey-40 inline-flex justify-between items-center w-full">
            <span>{{ t.GameDetails.Player }}:</span>
            <div class="inline-flex gap-2 items-center">
                <UserAvatar
                    size="24px"
                    :src="history?.user?.avatar"
                />
                <span class="text-white">
                    {{ history.user?.name }}
                </span>
            </div>
        </div>
        <div class="text-grey-40 inline-flex justify-between items-center w-full">
            <span>{{ t.GameDetails.Date }}:</span>
            <span> {{ sDate }} </span>
        </div>
        <div class="text-grey-40 inline-flex justify-between items-center w-full">
            <span class="whitespace-nowrap">
                {{ t.GameDetails.BetId }}:
            </span>
            <p class="flex gap-1 items-center flex-nowrap ml-auto"
                :style="{
                    'width': 'calc(100% - 60px)',
                    'justify-content': 'flex-end',
                }" 
            > 
                <span class="truncate"
                    :style="{ 'max-width': 'calc(100% - 50px)'}"
                    :title="history._id" 
                >
                    {{ history._id }}
                </span>
                <ButtonCopy
                    class="bg-grey-60 mr-0 ml-1"
                    :value="history._id"
                />
            </p>
        </div>
    </div>
</template>


<script lang="ts" setup>
import moment from 'moment';
import useTranslation from '~/i18n/useTransLation';
import { useGameIdListStore } from '~/stores/cansino/gameIdList';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const gameName = ref(null);
const oTheI18n = useI18n();
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        default: ()=>({}),
    },
});
// props.history
// 获取游戏名称
watch(
    () => props.history,
    () => {
        const {id} = props?.history?.game || {};
        if (!id) return;
        useGameIdListStore().gameIdNameList.find((item) => {
            if (item.id === id) {
                gameName.value = item.title;
                return true;
            }
        });
    },
    { immediate: true },
);
const t = useTranslation();

const sDate = computed(() => {
    const sFormst = (
        oTheI18n.locale.value === 'cn'
        ? 'YYYY/MM/DD, HH:mm:ss'
        : 'MM/DD/YYYY, hh:mm:ss A'
    );
    return moment(props.history.timestamp).format(sFormst);
});
</script>
